import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationHelperService {
  constructor(private translateService: TranslateService) {}

  translateArray<T>(array: string[], reducer: (value: string, translatedValue: string, index: number) => T, translationCodePrefix?: string): Observable<T[]> {
    const translationCodes = array.map(value => (translationCodePrefix || '') + value);
    const subject = new ReplaySubject<T[]>();
    this.translateService.get(translationCodes).subscribe((translatedValues: string[]) => {
      subject.next(array.map((value, idx) => reducer(value, translatedValues[(translationCodePrefix || '') + value], idx)));
      subject.complete();
    });
    return subject.asObservable();
  }

  translateArrayInstant<T>(array: string[], reducer: (value: string, translatedValue: string, index: number) => T, translationCodePrefix?: string): T[] {
    const translationCodes = array.map(value => (translationCodePrefix || '') + value);
    const translatedValues = this.translateService.instant(translationCodes);
    return array.map((value, idx) => reducer(value, translatedValues[(translationCodePrefix || '') + value], idx));
  }

  /**
   * Translate string codes and return translations in an object with key = code & value = translation
   * @param {string[]} array string-codes to be translated
   * @param {string} translationCodePrefix translationCodePrefix.  Will not be used to store in object
   * @returns {any} Observable that will return an object with translations
   */
  async translateArrayToObject(array: string[], params?: any, translationCodePrefix?: string): Promise<{ [key: string]: string }> {
    const translationCodes = array.map(value => (translationCodePrefix || '') + value);
    const translatedValues = await this.translateService.get(translationCodes, params);

    return array.reduce((res, value) => {
      res[value] = translatedValues[(translationCodePrefix || '') + value];
      return res;
    }, {});
  }
}
